import { render, staticRenderFns } from "./inventoryRecords.vue?vue&type=template&id=2eea2c74&scoped=true"
import script from "./inventoryRecords.vue?vue&type=script&lang=js"
export * from "./inventoryRecords.vue?vue&type=script&lang=js"
import style0 from "./inventoryRecords.vue?vue&type=style&index=0&id=2eea2c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea2c74",
  null
  
)

export default component.exports